import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

/*
  Generated class for the CountryListProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CountryListProvider {
  constructor(public http: HttpClient) {}
  //Country list provider for profile-info

  loadCountrys(): Observable<any> {
    return this.http.get('assets/json/countryList.json');
  }
}



// WEBPACK FOOTER //
// ./src/providers/country-list/country-list.ts